import { render, staticRenderFns } from "./years-input.vue?vue&type=template&id=1960d0a2"
import script from "./years-input.vue?vue&type=script&lang=js"
export * from "./years-input.vue?vue&type=script&lang=js"
import style0 from "./years-input.vue?vue&type=style&index=0&id=1960d0a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports